import TagManager from 'react-gtm-module';

import { config } from '../../config';
import { createStore } from '../_core/createStore';
import { analyticStore } from './analyticStore';

const useAnalyticStore = createStore({
  creator: analyticStore({
    addEventListener: document.addEventListener.bind(document),
    config,
    removeEventListener: document.removeEventListener.bind(document),
    TagManager,
  }),
  id: 'analytic',
  middlewares: {
    devtools: true,
  },
});

export default useAnalyticStore;
